import { keyframes } from 'styled-components';

const breakpoints = ['576px', '768px', '992px', '1200px', '1400px'];
const bounce = keyframes`
    0%, 100% {
        transform: translateY(0);
        animation-timing-function: ease-in-out;
    }
    50% {
        transform: translateY(1px);
        animation-timing-function: ease-in;
    }
`;
export const theme = {
    colors: {
        transparent: 'transparent',
        hover: '#101825',
        secondary: '#e62e43',
        scrollBar: '#f1f1f1',
        scrollBarThumb: '#555',
        secondaryGreenTop: '#7FB45A',
        productSelectBorder: '#EEEEEE59',
        secondaryGreen: '#5D8D3B',
        productText: '#FFFFFF8F',
        secondaryGreen50: 'rgba(93,141,59,0.5)',
        secondaryGreen70: 'rgba(93,141,59,0.7)',
        secondaryGreen200: '#6B724B',
        secondaryGreen300: '#546216',
        secondaryGreen400: '#666E45',
        selectBackground: '#EFEFEF',
        imageTint: '#212C1475',
        menuList: '#888888',
        whiteBlog: '#F2EDE4',
        blogBorder: '#E9E9E9',
        listBorder: 'rgba(21, 38, 55, 0.2)',
        text: '#152637',
        white: '#fff',
        white50: 'rgba(255,255,255,0.5)',
        black: '#000000',
        black50: 'rgba(0,0,0,0.5)',
        formBorder: '#4A4A4A',
        red: '#dc004e',
        modalBg: 'rgba(34, 31 ,31 , 90%)',
        primary: '#152637',
        themeColor1: '#FFFDFA',
        themeColor2: '#EEE4D9',
        themeColor3: '#C9C9C7',
        themeColor4: '#FDFFF2',
        themeColor5: '#101825',
        themeColor6: '#F4F4F4',
        themeColor7: '#DDD',
        themeColor8: '#A7A7A7',
        themeColor9: '#F5F5F5',
        themeColor10: '#e9e9e9',
        socialBorder: '#F6F6F6',
        blackTheme: 'rgb(29, 35, 39)',
        whiteTheme: 'rgb(237,232,229)',
        grayTheme: 'rgb(156, 160, 151)',
        bodyColor: '#ede8e5',
        themeColor700: 'rgba(33,33,33,0.7)',
        themeColor600: '#4D4D4D',
        themeColor500: '#EEE4D9',
        themeColor400: '#B29474',
        themeColor300: '#B8936D',
        themeColor200: '#CFAE8B',
        themeColor100: '#EBD8C3',
        themeColor50: '#E4E0DB',
        formColorWarn: '#ff1010a3',
        subTitleBorder: '#A7A7A7',
        googleMapContent: '#1D1D1D',
        innerBannerTint: '#000000A8',
        modalImageWrapper: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 82.99%)',
        bannerTint: 'linear-gradient(180deg,rgba(0, 0, 0, 0) 0%,rgba(0, 0, 0, 0.5) 100%)',
    },
    fonts: {
        fontName: "Instrument Sans",
        body: 'Instrument Sans, Arial, Helvetica, freesans, sans-serif',
        heading: 'Instrument Sans',
    },
    fontSizes: {
        body: '16px',
        h1: '6.25rem',
        h2: '3rem',
        h3: '2.25rem',
        h4: '1.5rem',
        h5: '1rem',
        h6: '1rem',
        rem4: '4.25rem',
    },
    letterSpacing: {
        body: '0',
        h1: '-0.1875rem',
        h2: '-0.09rem',
        h3: '-0.0675rem',
        h4: '-0.075rem',
        h5: '0',
        h6: '0',
    },
    fontWeights: {
        body: 400,
        medium: 500,
        semiBold: 600,
        regular: 400,
        light: 300,
        bold: 'bold'
    },
    lineHeights: {
        body: '1.2',
        h1: '120%',
        h2: '120%',
        h3: '120%',
        h4: '120%',
        h5: '120%',
        h6: '120%',
    },
    radius: {
        sm: '3px',
        md: '5px',
        lg: '8px',
        rounded: '4px',
        circle: '50%',
        pill: '500px',
    },
    shadows: {
        default: '0 0 12px 3px rgba(0, 0, 0, 0.06)',
        sm: '0px -1px 1px 0px rgba(0,0,0, .2)',
        lg: '0 1rem 3rem rgba(0, 0, 0, .175)',
        input: '0 0 0 0.2rem rgb(1 104 250 / 25%)',
    },
    logoRatio: 'calc(140 / 140 * 100%)',
    indusTryRatio: 'calc(165 / 370 * 100%)',
    indusTryRatioMobile: 'calc(141 / 375 * 100%)',
    googleMapRatio: 'calc(210 / 145 * 100%)',
    googleMapRatioModal: 'calc(565 / 679 * 100%)',
    googleMapRatioMobile: 'calc(150 / 145 * 100%)',
    innerBanner: 'calc(628 / 1366 * 100%)',
    modalBlogWrapper: 'calc(350 / 235 * 100%)',
    modalImageWrapper: 'calc(300 / 275 * 100%)',
    memberImageRatio: 'calc(395 / 275 * 100%)',
    memberImageRatioMobile: 'calc(135 / 135 * 100%)',
    categoryProductMobile: 'calc(235 / 165 * 100%)',
    categoryProduct: 'calc(550 / 345 * 100%)',
    blogDetailsImageWrapper: 'calc(380 / 750 * 100%)',
    innerBannerMobile: 'calc(928 / 1366 * 100%)',
    blockquote: `
    background: rgba(93,141,59,0.5);
    color: white;
    padding: 18px 25px;
            opacity: 0.92;
     margin: 60px 0;
            font-weight: 300;
            font-size: 1.125rem;
            line-height: 1.53;
            letter-spacing: -0.03em;
    `,
    width50: `
    width: 50%;
	max-width: 50%;
    `,
    maxContainer: `
    max-width: 100% !important;
			margin: 0 !important;
			padding: 0 !important;
    `,
    backButton: `
    font-weight: 600;
                font-size: 0.875rem;
                line-height: 1.4286;
                letter-spacing: -0.03em;
    `,
    inlineFlexCenter: `
    display: inline-flex;
                    align-items: center;
    `,
    blogText: `
    font-weight: 400;
            font-size: 1.25rem;
            line-height: 1.53;
            letter-spacing: -0.03em;
    `,
    contactCloseButton: `
     position: absolute;
        top: 40px;
        right: 40px;
        z-index: 999;
    `,
    backButtonSvg: `
     width: 8px;
                height: 8px;
                flex-shrink: 0;
    `,
    blogH5: `
     font-weight: 400;
            font-size: 1.25rem;
            line-height: 0.52;
            letter-spacing: -0.023em;
    `,
    blogHeading: `
         font-weight: 500;
                font-size: 3rem;
                line-height: 1.09;
                letter-spacing: -0.03em;
    `,
    backButtonList: `
        font-weight: 400;
                    font-size: 0.875rem;
                    line-height: 1.2;
                    letter-spacing: 0;
    `,
    bannerContainer: `
     position: absolute;
            left: 0;
            right: 0;
            z-index: 2;
            display: flex;
            justify-content: center;
            flex-direction: column;
            height: 100%;
    `,
    bannerTitle: `
     font-weight: 500;
     font-size: 6.25rem;
     line-height: 120%;
     letter-spacing: -0.03em;
    `,
    bannerTitleMobile: `
        font-weight: 500 !important;
                font-size: 3.125rem !important;
                line-height: 1.2 !important;
                letter-spacing: -0.03em !important;
    `,
    flexCenter: `
    display: flex;
    align-items: center;
    justify-content: center;
    `,
    flexCol: `
    display: flex;
    flex-direction: column;

    `,
    absoluteFill: `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
    absoluteFillBottom: `
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  `,
    absoluteFillBottom50: `
    position: absolute;
    right: 0;
    bottom: 50px;
    left: 0;
  `,
    absoluteFillTopTop: `
    position: absolute;
    right: 0;
    top: 0;
    left: 0;
  `,
    absoluteFillTop: `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
    fontGroup12:`
    font-size: 1.125rem;
            line-height: 1.2;
            letter-spacing: 0;
    `,
    contactFormText:`
    font-weight: 500;
                font-size: 1.125rem;
                line-height: 1.2;
                letter-spacing: -0.03em;
    `,
    flex50:`
    width: calc(50% - 30px);
                        flex: 0 0 calc(50% - 30px);
    `,
    mainFont: `
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: -0.03em;
  `,
    LinkOnly: `
    font-weight: 500 !important;
                    font-size: 1rem !important;
                    line-height: 1.2 !important;
                    letter-spacing: -0.03em !important;
    `,
    mainFont500: `
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.03em;
  `,
    visibilityHidden: `
    opacity: 0;
					visibility: hidden;
    `,
    visibilityVisible: `
    opacity: 1;
					visibility: visible;
    `,
    mainFont13Italic: `
    font-weight: 400;
                        font-style: italic;
                        font-size: 0.8125rem; 
                        line-height: 1.2; 
                        letter-spacing: -0.03em; 
  `,
    fontGroup24: `
    font-weight: 500;
                    font-size: 1.5rem; 
                    line-height: 1.2; 
                    letter-spacing: -0.03em; 
    
    `,
    fontGroup24400: `
    font-weight: 400;
                    font-size: 1.5rem; 
                    line-height: 1.2; 
                    letter-spacing: -0.03em; 
    
    `,
    fontGroup24500: `
    font-weight: 500;
                    font-size: 1.5rem; 
                    line-height: 1.2; 
                    letter-spacing: -0.03em; 
    
    `,
    fontGroup18600: `
    font-weight: 600;
            font-size: 1.15625rem;
            line-height: 1.2;
            letter-spacing: -0.03em;
    
    `,
    fontGroup14: `
    font-weight: 400;
                    font-size: 0.875rem;       
                    line-height: 1.2;            
                    letter-spacing: 0; 
    
    `,
    mainTitle: `
   font-weight: 600;
                font-size: 1.25rem;
                line-height: 1.2;
                letter-spacing: -0.03em;
  `,
    designationText: `
     font-weight: 400;
                    font-size: 0.875rem;
                    line-height: 1.2;
                    letter-spacing: -0.03em;
    `,
    mainTitle500: `
   font-weight: 500;
                font-size: 1.25rem;
                line-height: 1.2;
                letter-spacing: -0.03em;
  `,
    counterLarge: `
    position: relative;
                    display: flex;
                    align-items: center;
                    font-weight: 700;
                    font-size: 13.75rem;
                    line-height: 1.2;
                    letter-spacing: -0.03em;
    `,
    clickToSee: `
    font-weight: 400;
                        font-size: 0.75rem;
                        line-height: 1.2;
                        letter-spacing: -0.03em;
    `,
    innerBannerTitleMobile: `
    font-weight: 500;
            font-size: 2.5rem !important;
            line-height: 1.2 !important;
            letter-spacing: -0.03em;
    `,
    innerBannerTitle: `
      font-weight: 500;
            font-size: 6.25rem;
            line-height: 120%;
            letter-spacing: -0.03em;
    `,
    blogImageRation: `
    padding-top: calc(448 / 375 * 100%);
    position: relative;
    `,
    secondTitle: `
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.2;
    letter-spacing: -0.03em;
  `,
    transformMiddle: `
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
    `,
    viewHeight: `
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    `,
    relativeHidden: `
    position: relative;
    overflow: hidden;
    `,
    displayNone: `
    display: none;
    `,
    displayBlock: `
    display: block;
    `,
    backgroundCover: `
    background-repeat: no-repeat !important;
	background-size: cover !important;
	background-position: center  !important;
    `,
    productListBackground: `url("/images/static/productlist.jpg")`,
    productListBackgroundMobile: `url("/images/static/product-list-mb.jpg")`,
    fullHeightWidth: ` 
    height: 100%;
        width: 100%;`,
    breakpoints: [...breakpoints],
    transition: 'all 0.7s cubic-bezier(0.25, 0.74, 0.22, 0.99) 0s',
    transitionDelay: '0.5s',
    clippath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
    animations: {
        bounce,
    },
};